(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const target = document.getElementById('scroll-here');
  
  if (target) {
    const params = new URLSearchParams(window.location.search);
    const page = params.get("page");
 
    if (page) {
      target.scrollIntoView({ behavior: 'instant' });
    }
  }


  } catch(e) { console.error(e); }
})();
})();
